import { Box } from "@mui/material"
import React, {
  memo,
  MutableRefObject,
  RefObject,
  useCallback,
  useMemo,
  useState,
} from "react"
import { useParams } from "react-router"

import { DGText } from "../../../components/common/DGText"
import {
  PlaylistItem,
  TColumn,
} from "../../../components/Player/UI/Modals/components/PlaylistItem"
import { PlaylistFocusKeys } from "../../../components/Player/UI/Modals/playlist-focus-keys"
import { useAccessCheck } from "../../../hooks/use-access-check"
import { useTransitions } from "../../../hooks/use-transitions"
import { appStore } from "../../../store/AppStore"
import {
  PlaybackContent,
  playerStore,
  usePlayList,
} from "../../../store/PlayerStore"
import { comb, instantScroll, s } from "../../../utilities/common"
import { dimensions } from "../../../utilities/constants"
import { theme, TI } from "../../../utilities/theme"
import { useDetailStore } from "../DetailStore"

export const Playlist = memo(
  ({
    scrollRef,
    loginOpen,
    subscribeOpen,
    fk,
  }: {
    scrollRef: RefObject<HTMLElement | null>
    loginOpen: comb<boolean>
    subscribeOpen: comb<boolean>
    fk: MutableRefObject<string>
  }) => {
    const { type } = useParams()
    const content = useDetailStore((state) => state.content)
    const page = useDetailStore((state) => state.page)
    const playlist = usePlayList(content)
    const currentUser = appStore((state) => state.currentUser)
    const { accessCheck: accessCheckRaw } = useAccessCheck({
      loginOpen,
      subscribeOpen,
      focusKey: fk,
    })

    const setNavigationProps = playerStore((state) => state.setNavigationProps)
    const setReturnFocus = playerStore((state) => state.setReturnFocus)
    const setContentPlayer = playerStore((state) => state.setContent)

    const accessCheck = useCallback(() => accessCheckRaw({ page }), [page])

    const [column, setColumn] = useState<TColumn>("item")

    const favorites = useDetailStore((state) => state.favorites)
    const hasFavoriteIcon = useMemo(() => {
      return !!currentUser && content?.__typename === "VodConcert"
    }, [currentUser, content])

    const transition = useTransitions()

    // TODO refactor repeated code in playlistmodal
    return (
      <>
        {playlist && page
          ? playlist.map((trackSet) => (
              <Box
                key={"detailsscreen-trackset" + trackSet.id}
                sx={{
                  position: "relative",
                  width: hasFavoriteIcon ? s("1100px") : s("1150px"),
                  left: s("244px"),
                  mb: s("40px"),
                }}
              >
                {content?.__typename === "Album" && trackSet.composerTitle && (
                  <>
                    <DGText
                      tx={TI.Subheadline05tv}
                      sx={{
                        width: s("900px"),
                        mb: s("10px"),
                        color: theme.palette.white[55],
                        textAlign: "center",
                      }}
                    >
                      {trackSet.composerTitle}
                    </DGText>
                    <DGText
                      tx={TI.Subheadline02tv}
                      sx={{
                        width: s("900px"),
                        mb: s("48px"),
                        color: theme.palette.white.main,
                        textAlign: "center",
                      }}
                    >
                      {trackSet.title}
                    </DGText>
                  </>
                )}
                {trackSet.items.map((item, i) => (
                  <PlaylistItem
                    index={i}
                    key={"detailsscreen-listitem" + item.id}
                    data={item}
                    me={"Detailpage"}
                    onPress={async (itemId) => {
                      if (content?.__typename === "LiveConcert") return
                      if (!(await accessCheck())) return
                      setReturnFocus(
                        "Detailpage" + PlaylistFocusKeys.Item + itemId,
                      )
                      setContentPlayer(
                        content as PlaybackContent,
                        itemId,
                        false,
                      )
                      setNavigationProps({
                        open: true,
                        id: page.id,
                        type,
                        isPreview: "false",
                        trackId: itemId,
                      })
                    }}
                    paused={true}
                    onFocus={({ top: y }, _, query) => {
                      if (!(query && query.noScroll) && !!scrollRef.current) {
                        instantScroll(scrollRef, query, transition)
                        scrollRef.current.style.transform =
                          "translate3d(0, " +
                          Math.min(0, -y + dimensions.height / 2 - s(100)) +
                          "px, 0)"
                      }
                    }}
                    column={comb.ine(column, setColumn)}
                    hasFavoriteButton={hasFavoriteIcon}
                    isFavorite={
                      content?.__typename === "VodConcert" &&
                      favorites.vodConcert &&
                      favorites.vodConcert.includes(item.id)
                    }
                  />
                ))}
              </Box>
            ))
          : null}
      </>
    )
  },
)
